import { useMutation } from '@apollo/client';
import { VIEW_FRONT_ENHANCED_REVIEW } from '../../graphql/user-mutations';

export default function useMutateViewEnhancedReview() {
    const [mutateViewEnhancedReview] = useMutation(VIEW_FRONT_ENHANCED_REVIEW);
    return { mutateViewEnhancedReview };
}
